const MemoryGameLibraryData = [
    {
        id: 1,
        name: "Mystery",
        type: "picture",
        itemImg: "magnifyingGlass.png",
        matched: false,
    },
    {
        id: 2,
        name: "Mystery",
        type: "text",
        itemName: "Mystery",
        matched: false,
    },
    {
        id: 3,
        name: "ScienceFiction",
        type: "picture",
        itemImg: "rocketShip.png",
        matched: false,
    },
    {
        id: 4,
        name: "ScienceFiction",
        type: "text",
        itemName: "Science Fiction",
        matched: false,
    },
    {
        id: 5,
        name: "Fantasy",
        type: "picture",
        itemImg: "dragon.png",
        matched: false,
    },
    {
        id: 6,
        name: "Fantasy",
        type: "text",
        itemName: "Fantasy",
        matched: false,
    },
    {
        id: 7,
        name: "Horror",
        type: "picture",
        itemImg: "skull.png",
        matched: false,
    },
    {
        id: 8,
        name: "Horror",
        type: "text",
        itemName: "Horror",
        matched: false,
    },
    {
        id: 9,
        name: "Romance",
        type: "picture",
        itemImg: "heart.png",
        matched: false,
    },
    {
        id: 10,
        name: "Romance",
        type: "text",
        itemName: "Romance",
        matched: false,
    },
    {
        id: 11,
        name: "Western",
        type: "picture",
        itemImg: "cowboyHat.png",
        matched: false,
    },
    {
        id: 12,
        name: "Western",
        type: "text",
        itemName: "Western",
        matched: false,
    },
    {
        id: 13,
        name: "FairyTale",
        type: "picture",
        itemImg: "castle.png",
        matched: false,
    },
    {
        id: 14,
        name: "FairyTale",
        type: "text",
        itemName: "Fairy Tale",
        matched: false,
    },
   
    {
        id: 15,
        name: "Adventure",
        type: "picture",
        itemImg: "treasureChest.png",
        matched: false,
    },
    {
        id: 16,
        name: "Adventure",
        type: "text",
        itemName: "Adventure",
        matched: false,
    },
    {
        id: 17,
        name: "Astronomy",
        type: "picture",
        itemImg: "telescope.png",
        matched: false,
    },
    {
        id: 18,
        name: "Astronomy",
        type: "text",
        itemName: "Astronomy",
        matched: false,
    },
    {
        id: 19,
        name: "Chemistry",
        type: "picture",
        itemImg: "beaker.png",
        matched: false,
    },
    {
        id: 20,
        name: "Chemistry",
        type: "text",
        itemName: "Chemistry",
        matched: false,
    },
    {
        id: 21,
        name: "Mathematics",
        type: "picture",
        itemImg: "mathSymbols.png",
        matched: false,
    },
    {
        id: 22,
        name: "Mathematics",
        type: "text",
        itemName: "Math",
        matched: false,
    },
      {
        id: 23,
        name: "Physics",
        type: "picture",
        itemImg: "atom.png",
        matched: false,
    },
    {
        id: 24,
        name: "Physics",
        type: "text",
        itemName: "Physics",
        matched: false,
    },
    {
        id: 25,
        name: "Cooking",
        type: "picture",
        itemImg: "chefHat.png",
        matched: false,
    },
    {
        id: 26,
        name: "Cooking",
        type: "text",
        itemName: "Cooking",
        matched: false,
    },
     {
        id: 27,
        name: "Gardening",
        type: "picture",
        itemImg: "trowel.png",
        matched: false,
    },
    {
        id: 28,
        name: "Gardening",
        type: "text",
        itemName: "Gardening",
        matched: false,
    },
    {
        id: 29,
        name: "Music",
        type: "picture",
        itemImg: "musicalNotes.png",
        matched: false,
    },
    {
        id: 30,
        name: "Music",
        type: "text",
        itemName: "Music",
        matched: false,
    },
    {
        id: 31,
        name: "Art",
        type: "picture",
        itemImg: "paintPalette.png",
        matched: false,
    },
    {
        id: 32,
        name: "Art",
        type: "text",
        itemName: "Art",
        matched: false,
    },
    {
        id: 41,
        name: "Sports",
        type: "picture",
        itemImg: "sports.png",
        matched: false,
    },
    {
        id: 42,
        name: "Sports",
        type: "text",
        itemName: "Sports",
        matched: false,
    },
    {
        id: 43,
        name: "MarineLife",
        type: "picture",
        itemImg: "fish.png",
        matched: false,
    },
    {
        id: 44,
        name: "MarineLife",
        type: "text",
        itemName: "Marine Life",
        matched: false,
    },
      {
        id: 45,
        name: "Dinosaurs",
        type: "picture",
        itemImg: "dinosaur.png",
        matched: false,
    },
    {
        id: 46,
        name: "Dinosaurs",
        type: "text",
        itemName: "Dinosaurs",
        matched: false,
    },
     {
        id: 47,
        name: "Travel",
        type: "picture",
        itemImg: "suitcase.png",
        matched: false,
    },
    {
        id: 48,
        name: "Travel",
        type: "text",
        itemName: "Travel",
        matched: false,
    },
    {
        id: 49,
        name: "Weather",
        type: "picture",
        itemImg: "cloudLightning.png",
        matched: false,
    },
    {
        id: 50,
        name: "Weather",
        type: "text",
        itemName: "Weather",
        matched: false,
    },
     {
        id: 51,
        name: "Automobiles",
        type: "picture",
        itemImg: "car.png",
        matched: false,
    },
    {
        id: 52,
        name: "Automobiles",
        type: "text",
        itemName: "Autos",
        matched: false,
    },
    /*
   
    {
        id: 45,
        name: "Animals",
        type: "picture",
        itemImg: "pawPrint.png",
        matched: false,
    },
    {
        id: 46,
        name: "Animals",
        type: "text",
        itemName: "Animals",
        matched: false,
    },
   
  
    {
        id: 53,
        name: "SpaceExploration",
        type: "picture",
        itemImg: "astronautHelmet.png",
        matched: false,
    },
    {
        id: 54,
        name: "SpaceExploration",
        type: "text",
        itemName: "Space Exploration",
        matched: false,
    },
   
    {
        id: 57,
        name: "Photography",
        type: "picture",
        itemImg: "camera.png",
        matched: false,
    },
    {
        id: 58,
        name: "Photography",
        type: "text",
        itemName: "Photography",
        matched: false,
    },
    {
        id: 59,
        name: "Computers",
        type: "picture",
        itemImg: "laptop.png",
        matched: false,
    },
    {
        id: 60,
        name: "Computers",
        type: "text",
        itemName: "Computers",
        matched: false,
    },
    {
        id: 61,
        name: "Bookshelf",
        type: "picture",
        itemImg: "bookshelf.png",
        matched: false,
    },
    {
        id: 62,
        name: "Bookshelf",
        type: "text",
        itemName: "Bookshelf",
        matched: false,
    },
    {
        id: 63,
        name: "BookCart",
        type: "picture",
        itemImg: "bookCart.png",
        matched: false,
    },
    {
        id: 64,
        name: "BookCart",
        type: "text",
        itemName: "Book Cart",
        matched: false,
    },
    {
        id: 65,
        name: "LibraryCard",
        type: "picture",
        itemImg: "libraryCard.png",
        matched: false,
    },
    {
        id: 66,
        name: "LibraryCard",
        type: "text",
        itemName: "Library Card",
        matched: false,
    },
    {
        id: 67,
        name: "DueDateStamp",
        type: "picture",
        itemImg: "rubberStamp.png",
        matched: false,
    },
    {
        id: 68,
        name: "DueDateStamp",
        type: "text",
        itemName: "Due Date Stamp",
        matched: false,
    },
    {
        id: 69,
        name: "BarcodeScanner",
        type: "picture",
        itemImg: "barcodeScanner.png",
        matched: false,
    },
    {
        id: 70,
        name: "BarcodeScanner",
        type: "text",
        itemName: "Barcode Scanner",
        matched: false,
    },
    {
        id: 71,
        name: "Audiobook",
        type: "picture",
        itemImg: "headphones.png",
        matched: false,
    },
    {
        id: 72,
        name: "Audiobook",
        type: "text",
        itemName: "Audiobook",
        matched: false,
    },
    {
        id: 73,
        name: "GraphicNovel",
        type: "picture",
        itemImg: "speechBubble.png",
        matched: false,
    },
    {
        id: 74,
        name: "GraphicNovel",
        type: "text",
        itemName: "Graphic Novel",
        matched: false,
    },
    {
        id: 75,
        name: "Atlas",
        type: "picture",
        itemImg: "foldedMap.png",
        matched: false,
    },
    {
        id: 76,
        name: "Atlas",
        type: "text",
        itemName: "Atlas",
        matched: false,
    },
    {
        id: 77,
        name: "Newspaper",
        type: "picture",
        itemImg: "newspaper.png",
        matched: false,
    },
    {
        id: 78,
        name: "Newspaper",
        type: "text",
        itemName: "Newspaper",
        matched: false,
    },
    {
        id: 79,
        name: "Encyclopedia",
        type: "picture",
        itemImg: "encyclopediaBooks.png",
        matched: false,
    },
    {
        id: 80,
        name: "Encyclopedia",
        type: "text",
        itemName: "Encyclopedia",
        matched: false,
    },
    /*
     {
        id: 13,
        name: "SpyThriller",
        type: "picture",
        itemImg: "spySilhouette.png",
        matched: false,
    },
    {
        id: 14,
        name: "SpyThriller",
        type: "text",
        itemName: "Spy Thriller",
        matched: false,
    },
     {
        id: 17,
        name: "Mythology",
        type: "picture",
        itemImg: "lightningBolt.png",
        matched: false,
    },
    {
        id: 18,
        name: "Mythology",
        type: "text",
        itemName: "Mythology",
        matched: false,
    },
     {
        id: 25,
        name: "Biology",
        type: "picture",
        itemImg: "dnaHelix.png",
        matched: false,
    },
    {
        id: 26,
        name: "Biology",
        type: "text",
        itemName: "Biology",
        matched: false,
    },
    {
        id: 35,
        name: "Architecture",
        type: "picture",
        itemImg: "blueprints.png",
        matched: false,
    },
    {
        id: 36,
        name: "Architecture",
        type: "text",
        itemName: "Architecture",
        matched: false,
    },
    */
    
];
export default MemoryGameLibraryData;